import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 11.0355H21V13.0355H13V21.0355H11V13.0355H3V11.0355H11V3.03546H13V11.0355Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlus);
const Memo = memo(ForwardRef);
export default Memo;
